var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.isLoading)?_c('v-app',{attrs:{"id":"inspire"}},[_c(_setup.TheNavBar),_c('v-main',{staticClass:"white"},[_c('router-view')],1),_c(_setup.TheFooter)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }